import _ from "lodash";

export const buildTabsStylesheet = (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    let maxWidth;
    if (
      options["tabs-max-width-style"] == "custom" &&
      options["tabs-max-width-value"]
    ) {
      maxWidth = `${options["tabs-max-width-value"]}px !important`;
    } else if (options["tabs-max-width-style"] == "full") {
      maxWidth = "100% !important";
    }

    let tabsAlignment = "";
    if (
      options["tabs-layout"] == "horizontal" ||
      (options["tabs-layout"] == "" &&
        variant.options["tabs-layout"] == "horizontal")
    ) {
      tabsAlignment = options["tabs-alignment"];
    }

    let tabsFontFamily = options["tabs-font-family"] || undefined;
    let tabsFontWeight = options["tabs-font-weight"] || undefined;
    let tabsFontSize = options["tabs-font-size"] || undefined;
    let tabsFontColor = options["tabs-font-color"] || undefined;
    let tabsFontColorHover = options["tabs-font-color-hover"] || undefined;
    let tabsFontColorActive = options["tabs-font-color-active"] || undefined;
    let tabsBackgroundColor = options["tabs-background-color"] || undefined;
    let tabsBackgroundColorHover =
      options["tabs-background-color-hover"] || undefined;
    let tabsBackgroundColorActive =
      options["tabs-background-color-active"] || undefined;

    let tabsBorderRadius = "";
    if (options["tabs-radius"] == "cf-not-rounded") {
      tabsBorderRadius = "0px";
    }
    if (options["tabs-radius"] == "cf-slightly-rounded") {
      tabsBorderRadius = "4px";
    }
    if (options["tabs-radius"] == "cf-fully-rounded") {
      tabsBorderRadius = "100px";
    }
    if (options["tabs-radius"] == "custom") {
      tabsBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          tabsBorderRadius += `${
            _.isNil(options["tabs-radius-" + side]) == false
              ? options["tabs-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let tabsItemPadding = "";
    if (options["tabs-padding-style"] == "custom") {
      tabsItemPadding = options["tabs-padding-value"];
    }

    let tabsContentBackgroundColor =
      options["tabs-content-background-color"] || undefined;

    let tabsContentBorderRadius = "";
    if (options["tabs-content-radius"] == "cf-not-rounded") {
      tabsContentBorderRadius = "0px";
    }
    if (options["tabs-content-radius"] == "cf-slightly-rounded") {
      tabsContentBorderRadius = "4px";
    }
    if (options["tabs-content-radius"] == "cf-fully-rounded") {
      tabsContentBorderRadius = "100px";
    }
    if (options["tabs-content-radius"] == "custom") {
      tabsContentBorderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          tabsContentBorderRadius += `${
            _.isNil(options["tabs-content-radius-" + side]) == false
              ? options["tabs-content-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    if (tabsItemPadding === "" && variant.options["tabs-padding-style"] === "custom") {
      tabsItemPadding = variant.options["tabs-padding-value"] || 0;
    }

    let tabsContentSpacingHorizontal =
      options["tabs-content-spacing-horizontal"] || variant.options["tabs-content-spacing-horizontal"] || undefined;
    let tabsContentSpacingVertical =
      options["tabs-content-spacing-vertical"] || variant.options["tabs-content-spacing-vertical"] || undefined;
    let tabsWidth = options["tabs-width"] || variant.options["tabs-width"] || undefined;

    let tabsBorderColor = options["tabs-border-color"] || undefined;
    let tabsBorderColorActive =
      options["tabs-border-color-active"] || undefined;
    let tabsBorderColorHover = options["tabs-border-color-hover"] || undefined;

    const desktopChoosedLayout = element.options["tabs-layout"] || variant.options["tabs-layout"] || "horizontal";

    // prettier-ignore
    const desktopStyles =
      `#cta_${cta.id} .cf-element .cf-tabs-element[data-element-id="${element.id}"] {
        ${maxWidth ? `max-width: ${maxWidth};` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .disabled-item {
        height: unset;
      }

      ${desktopChoosedLayout === "horizontal" ? `
        #cta_${cta.id} .cf-element .cf-tabs-element[data-element-id="${element.id}"] > .cf-tabs-container {
          flex-direction: column;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;
          ${tabsContentSpacingHorizontal ? `margin-bottom: ${tabsContentSpacingHorizontal}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"] {
          ${tabsWidth ? `width: ${tabsWidth}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"].active:hover {
          ${options["tabs-border-style"] || variant.options["tabs-border-style"] ? '' : tabsFontColorHover ? `border-bottom: 2px solid ${tabsFontColorHover} !important;` : 'border-bottom: 2px solid #1e90ff;' }
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"].active {
          ${options["tabs-border-style"] || variant.options["tabs-border-style"] ? '' : tabsFontColorActive ? `border-bottom: 2px solid ${tabsFontColorActive} !important;` : 'border-bottom: 2px solid #1e90ff;' }
        }
      ` : ''}

      ${desktopChoosedLayout === "vertical" ? `
        #cta_${cta.id} .cf-element .cf-tabs-element[data-element-id="${element.id}"] > .cf-tabs-container {
          flex-direction: row;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"] .cf-label {
          ${tabsFontSize ? `font-size: ${tabsFontSize - 3}px;` : ''}
          color: grey;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
          display: flex;
          flex-direction: column;
          ${tabsContentSpacingVertical ? `margin-right: ${tabsContentSpacingVertical}px !important;` : ''}
          ${tabsWidth ? `width: ${tabsWidth}px !important;` : 'width: 25%;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-section-box[data-tab-element-id="${element.id}"] {
          flex: 1;
        }
      ` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-section-box[data-tab-element-id="${element.id}"] {
        ${tabsContentBackgroundColor ? `background: ${tabsContentBackgroundColor};` : ''}
        ${options["tabs-content-border-style"] ? `border-style: ${options["tabs-content-border-style"]} !important;` : ''}
        ${_.isNil(options["tabs-content-border-width"]) == false ? 'border-width: ' + options["tabs-content-border-width"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-content-border-width-left"]) == false ? 'border-left-width: ' + options["tabs-content-border-width-left"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-content-border-width-right"]) == false ? 'border-right-width: ' + options["tabs-content-border-width-right"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-content-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["tabs-content-border-width-bottom"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-content-border-width-top"]) == false ? 'border-top-width: ' + options["tabs-content-border-width-top"] + 'px !important;' : ''}
        ${options["tabs-content-border-color"] ? `border-color: ${options["tabs-content-border-color"]} !important;` : 'border-color: #000000;'}
        ${tabsContentBorderRadius ? 'border-radius: ' + tabsContentBorderRadius + ' !important;' : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
        gap: 10px;
        ${tabsAlignment ? `justify-content: ${tabsAlignment} !important;` : ''}
        ${tabsFontWeight ? `font-weight: ${tabsFontWeight} !important;` : ''}
        ${tabsFontSize ? `font-size: ${tabsFontSize}px !important;` : ''}
        ${tabsFontColor ? `color: ${tabsFontColor} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element .cf-tab-item[data-tab-element-id="${element.id}"]:hover,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element .cf-tab-item[data-tab-element-id="${element.id}"].active:hover {
        ${tabsFontColorHover ? `color: ${tabsFontColorHover} !important;` : ''}
        ${tabsBackgroundColorHover ? `background: ${tabsBackgroundColorHover} !important;` : ''}
        ${tabsBorderColorHover ? `border-color: ${tabsBorderColorHover} !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element .cf-tab-item[data-tab-element-id="${element.id}"] {
        overflow: hidden;
        ${tabsBackgroundColor ? `background: ${tabsBackgroundColor};` : ''}
        ${options["tabs-border-style"] ? `border-style: ${options["tabs-border-style"]} !important;` : ''}
        ${_.isNil(options["tabs-border-width"]) == false ? 'border-width: ' + options["tabs-border-width"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-border-width-left"]) == false ? 'border-left-width: ' + options["tabs-border-width-left"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-border-width-right"]) == false ? 'border-right-width: ' + options["tabs-border-width-right"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["tabs-border-width-bottom"] + 'px !important;' : ''}
        ${_.isNil(options["tabs-border-width-top"]) == false ? 'border-top-width: ' + options["tabs-border-width-top"] + 'px !important;' : ''}
        ${tabsBorderColor ? `border-color: ${tabsBorderColor} !important;` : ''}
        ${tabsBorderRadius ? 'border-radius: ' + tabsBorderRadius + ' !important;' : ''}
        ${tabsItemPadding ? `padding: ${tabsItemPadding}px !important;` : desktopChoosedLayout === 'horizontal' ? 'padding: 15px 25px;' : 'padding: 25px;'}
        ${tabsFontFamily ? `font-family: ${tabsFontFamily}, Helvetica, Arial, sans-serif !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element .cf-tab-item[data-tab-element-id="${element.id}"].active:not(:hover) {
        ${tabsFontColorActive ? `color: ${tabsFontColorActive} !important;` : ''}
        ${tabsBackgroundColorActive ? `background: ${tabsBackgroundColorActive};` : ''}
        ${tabsBorderColorActive ? `border-color: ${tabsBorderColorActive} !important;` : ''}
      }
      `;

    let maxWidthMobile;
    if (
      options["tabs-max-width-style-mobile"] == "custom" &&
      options["tabs-max-width-value-mobile"]
    ) {
      maxWidthMobile = `${options["tabs-max-width-value-mobile"]}px !important`;
    } else if (options["tabs-max-width-style-mobile"] == "full") {
      maxWidthMobile = "100% !important";
    }

    let tabsFontSizeMobile = options["tabs-font-size-mobile"] || undefined;

    let tabsItemPaddingMobile = "";
    if (options["tabs-padding-style-mobile"] == "custom") {
      tabsItemPaddingMobile = options["tabs-padding-value-mobile"];
    }

    if (tabsItemPaddingMobile === "" && variant.options["tabs-padding-style-mobile"] == "custom") {
      tabsItemPaddingMobile = variant.options["tabs-padding-value-mobile"] || 0;
    }

    let tabsContentSpacingHorizontalMobile =
      options["tabs-content-spacing-horizontal-mobile"] || variant.options["tabs-content-spacing-horizontal-mobile"] || undefined;
    let tabsContentSpacingVerticalMobile =
      options["tabs-content-spacing-vertical-mobile"] || variant.options["tabs-content-spacing-vertical-mobile"] || undefined;
    let tabsWidthMobile = options["tabs-width-mobile"] || variant.options["tabs-width-mobile"] || undefined;

    const mobileChoosedLayout = element.options["tabs-layout-mobile"] || variant.options["tabs-layout-mobile"] || desktopChoosedLayout;

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element {
        ${maxWidthMobile ? `max-width: ${maxWidthMobile};` : ''}
      }

      ${mobileChoosedLayout === "horizontal" ? `
        #cta_${cta.id} .cf-element .cf-tabs-element[data-element-id="${element.id}"] > .cf-tabs-container {
          flex-direction: column;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;
          ${tabsContentSpacingHorizontalMobile ? `margin-bottom: ${tabsContentSpacingHorizontalMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"] {
          ${tabsWidthMobile ? `width: ${tabsWidthMobile}px !important;` : ''}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"]:hover,
        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"].active:hover {
          ${options["tabs-border-style"] || variant.options["tabs-border-style"] ? '' : tabsFontColorHover ? `border-bottom: 2px solid ${tabsFontColorHover} !important;` : 'border-bottom: 2px solid #1e90ff;' }
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"].active {
          ${options["tabs-border-style"] || variant.options["tabs-border-style"] ? '' : tabsFontColorActive ? `border-bottom: 2px solid ${tabsFontColorActive} !important;` : 'border-bottom: 2px solid #1e90ff;' }
        }
      ` : ''}

      ${mobileChoosedLayout === "vertical" ? `
        #cta_${cta.id} .cf-element .cf-tabs-element[data-element-id="${element.id}"] > .cf-tabs-container {
          flex-direction: row;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tab-item[data-tab-element-id="${element.id}"] .cf-label {
          ${tabsFontSizeMobile ? `font-size: ${tabsFontSizeMobile - 3}px !important;` : ''}
          color: grey;
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
          display: flex;
          flex-direction: column;
          ${tabsContentSpacingVerticalMobile ? `margin-right: ${tabsContentSpacingVerticalMobile}px !important;` : ''}
          ${tabsWidthMobile ? `width: ${tabsWidthMobile}px !important;` : 'width: 25%;'}
        }

        #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-section-box[data-tab-element-id="${element.id}"] {
          flex: 1;
        }
      ` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-container .cf-tabs-list[data-tab-element-id="${element.id}"] {
        ${tabsFontSizeMobile ? `font-size: ${tabsFontSizeMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-tabs-element .cf-tab-item[data-tab-element-id="${element.id}"] {
        ${tabsItemPaddingMobile ? `padding: ${tabsItemPaddingMobile}px !important;` : mobileChoosedLayout === 'horizontal' ? 'padding: 7px;' : 'padding: 25px;'}
      }
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
